import React from 'react';
import ImageRepositoryWidgetBuilder from './ImageRepositoryWidgetBuilder';
import ImageRepositoryWidgetRenderer from './ImageRepositoryWidgetRenderer';
import Preview from './Preview';
import type { WidgetDefinition } from '../../../registry';
import type { ImageRepositoryWidgetConfig } from './types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faImages } from '@fortawesome/free-solid-svg-icons';

export { default as ImageRepositoryWidgetBuilder } from './ImageRepositoryWidgetBuilder';
export { default as ImageRepositoryWidgetRenderer } from './ImageRepositoryWidgetRenderer';
export * from './types';

export const definition: WidgetDefinition = {
  type: 'image_repository',
  meta: {
    label: 'Image Repository',
    icon: React.createElement(FontAwesomeIcon, { icon: faImages }),
    description: 'Store and browse tagged images and screenshots',
    isSystem: true,
    isCreatable: false,
    shareable: true,
    dataFlow: 'both',
  },
  defaultSize: { w: 8, h: 6, minW: 6, minH: 5 },
  defaultConfig: () => ({
    allowUpload: true,
    allowDelete: true,
    allowTagging: true,
    gridView: true,
    thumbnailSize: 'medium',
  } as ImageRepositoryWidgetConfig),
  Builder: ImageRepositoryWidgetBuilder,
  Renderer: ImageRepositoryWidgetRenderer,
  Preview,
};
